/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaidPilotConfig } from './paidPilotConfig';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface IrrConfigSpec { 
    /**
     * IRR FQDN
     */
    irr_fqdn?: string;
    /**
     * IRR Public IP.
     */
    irr_public_ip: string;
    /**
     * Login OAuth app ID.
     */
    oauth_app_id: string;
    /**
     * Login OAuth app Secret.
     */
    oauth_app_secret: string;
    paid_pilot_config?: PaidPilotConfig;
    /**
     * Quick start enabled.
     */
    quick_start_eligible?: boolean;
    region: AWSRegionsEnum;
    /**
     * Server OAuth app ID.
     */
    server_oauth_app_id: string;
    /**
     * Server OAuth app Secret.
     */
    server_oauth_app_secret: string;
    service_type: ServiceTypeEnum;
    /**
     * Operator can skip several level of org and Ip address validation to be less strict.
     */
    skip_org_ip_validation?: boolean;
}
export namespace IrrConfigSpec {
}


